import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import Sheet from './sheet.jsx';

/**
 * Shared by the two places that can sign someone out (sidebar.jsx and
 * settings.jsx) — /logout itself still performs the actual sign-out with no
 * prompt, since it can also be reached as a direct URL and has to keep working
 * there. This is only the "are you sure" step in front of it.
 */
export default function LogoutConfirmSheet({ open, onClose }) {
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    const confirm = () => {
        onClose();
        navigate('/logout');
    };

    return (
        <Sheet open={open} onClose={onClose} title={t('logoutConfirmTitle')}>
            <p className="text-muted-ms mb-3">{t('logoutConfirmBody')}</p>
            <button type="button" className="btn-ms btn-ms-danger btn-ms-block" onClick={confirm}>
                <i className="bi bi-box-arrow-right" /> {t('logoutConfirmAction')}
            </button>
            <button type="button" className="btn-ms btn-ms-outline btn-ms-block mt-2" onClick={onClose}>
                {t('cancel')}
            </button>
        </Sheet>
    );
}
